/**
 * admin-internal-locale — 判定一个 locale 是否为「admin 内部预览 / 管理语言」。
 *
 * `zh` 及其全部地区变体（`zh-TW` / `zh-HK` / `zh-CN` …）只供 admin 后台界面渲染与运营操作管理，
 * **不参与 C 端任何运行时链路**：`apps.allowed_languages` 的 DB CHECK ④ 直接拒绝它入集合，
 * 书库可见判据 `locale = ANY(allowed_languages) OR locale = 'en'` 也永远取不到它
 * （dev-docs `03-数据字典/70-产品配置.md` §0 usage scope 速查 + §1 `allowed_languages`）。
 *
 * **判据必须按 base 前缀**，与 CHECK ④ 的谓词 `l = 'zh' OR l LIKE 'zh-%'` 逐字同款：
 * 写成精确 `=== 'zh'` 会被 `zh-TW` / `zh-CN` 绕过 —— 契约在 CHECK ④ 处专门点了这个坑。
 */
export function isAdminInternalLocale(locale: string): boolean {
  const normalized = locale.trim().toLowerCase();
  return normalized === 'zh' || normalized.startsWith('zh-');
}
